import * as VueRouter from 'vue-router';
import Home from '~/components/routes/Home.vue';
import EditProject from '~/components/routes/EditProject.vue';
export function createRouter() {
    return VueRouter.createRouter({
        history: VueRouter.createWebHashHistory(),
        routes: [
            {
                path: '/',
                name: 'home',
                component: Home,
            },
            {
                path: '/edit-projects',
                name: 'editProject',
                component: EditProject,
            },
        ],
    });
}
